const renderTextOrUnknown = (value) =>
  value ? (
    <span className="text-sm">{value}</span>
  ) : (
    <span className="text-sm italic text-gray-500">Không xác định</span>
  );
export { renderTextOrUnknown };
